/* SP Build Your Set — cross-sell cart handler. Discount enforced server-side via Shopify Automatic Discount. */
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.sp-build-your-set');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var threshold = parseInt(section.getAttribute('data-discount-threshold'), 10) || 4;
    var discountUsd = parseInt(section.getAttribute('data-discount-amount'), 10) || 12;
    var cards = section.querySelectorAll('[data-bys-card]');
    var counterEl = section.querySelector('[data-bys-counter]');
    var hintEl = section.querySelector('[data-bys-hint]');
    var errorEl = section.querySelector('[data-bys-error]');
    var ctaBtn = section.querySelector('[data-bys-add]');

    function fmt(cents) {
      var dollars = (cents / 100);
      if (dollars % 1 === 0) return '$' + dollars.toFixed(0);
      return '$' + dollars.toFixed(2);
    }

    function getSelection() {
      var items = [];
      var totalQty = 0;
      var subtotalCents = 0;
      cards.forEach(function (card) {
        var checkbox = card.querySelector('[data-bys-checkbox]');
        var qtyInput = card.querySelector('[data-bys-qty-input]');
        if (!checkbox || !qtyInput) return;
        if (!checkbox.checked) return;
        var qty = parseInt(qtyInput.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        var variantId = parseInt(card.getAttribute('data-variant-id'), 10);
        var priceCents = parseInt(card.getAttribute('data-price-cents'), 10) || 0;
        if (!variantId) return;
        items.push({ id: variantId, quantity: qty });
        totalQty += qty;
        subtotalCents += priceCents * qty;
      });
      return { items: items, totalQty: totalQty, subtotalCents: subtotalCents };
    }

    function updateUi() {
      var sel = getSelection();
      cards.forEach(function (card) {
        var checkbox = card.querySelector('[data-bys-checkbox]');
        if (checkbox && checkbox.checked) card.classList.add('is-selected');
        else card.classList.remove('is-selected');
      });
      if (counterEl) counterEl.textContent = 'Selected: ' + sel.totalQty + ' bottle' + (sel.totalQty === 1 ? '' : 's') + ' \u00b7 ' + fmt(sel.subtotalCents) + ' subtotal';
      if (hintEl) {
        if (sel.totalQty >= threshold) {
          hintEl.textContent = '\u2713 $' + discountUsd + ' discount will apply at checkout';
          hintEl.classList.add('sp-bys__hint--applied');
        } else {
          var remaining = threshold - sel.totalQty;
          hintEl.textContent = 'Add ' + remaining + ' more to save $' + discountUsd;
          hintEl.classList.remove('sp-bys__hint--applied');
        }
      }
      if (ctaBtn) ctaBtn.disabled = sel.totalQty === 0;
      if (errorEl) errorEl.textContent = '';
    }

    cards.forEach(function (card) {
      var checkbox = card.querySelector('[data-bys-checkbox]');
      var qtyInput = card.querySelector('[data-bys-qty-input]');
      var qtyButtons = card.querySelectorAll('[data-bys-qty]');
      if (checkbox) checkbox.addEventListener('change', updateUi);
      if (qtyInput) qtyInput.addEventListener('input', function () {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        if (v > 20) v = 20;
        qtyInput.value = v;
        if (checkbox && !checkbox.checked) checkbox.checked = true;
        updateUi();
      });
      qtyButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-bys-qty'), 10);
          var v = parseInt(qtyInput.value, 10);
          if (isNaN(v)) v = 1;
          v = Math.max(1, Math.min(20, v + delta));
          qtyInput.value = v;
          if (checkbox && !checkbox.checked) checkbox.checked = true;
          updateUi();
        });
      });
    });

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var sel = getSelection();
        if (sel.items.length === 0) {
          if (errorEl) errorEl.textContent = 'Select at least one bottle to continue.';
          return;
        }
        var originalText = ctaBtn.textContent;
        ctaBtn.disabled = true;
        ctaBtn.textContent = 'Adding...';
        if (errorEl) errorEl.textContent = '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: sel.items })
        })
          .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, status: res.status, body: body }; }); })
          .then(function (result) {
            if (!result.ok) {
              var msg = (result.body && (result.body.description || result.body.message)) || 'Could not add to cart. Please try again.';
              if (errorEl) errorEl.textContent = msg;
              ctaBtn.disabled = false;
              ctaBtn.textContent = originalText;
              return;
            }
            ctaBtn.textContent = 'Added';
            try {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'sp-build-your-set' } }));
            } catch (e) { /* no-op */ }
            setTimeout(function () {
              ctaBtn.disabled = false;
              ctaBtn.textContent = originalText;
            }, 1500);
          })
          .catch(function () {
            if (errorEl) errorEl.textContent = 'Network error. Please try again.';
            ctaBtn.disabled = false;
            ctaBtn.textContent = originalText;
          });
      });
    }

    updateUi();
  });
});
